import { Language } from 'src/app/@shared/services/language/language.service';

export const FROM_CITY = {
  hebrew: 'מיישוב',
  english: 'Origin city',
  arabic: 'المدينة الأصلية',
};

export const TO_CITY = {
  hebrew: 'עד יישוב',
  english: 'Destination city',
  arabic: 'مدينة الوجهة',
};

export const DATE = {
  hebrew: 'תאריך',
  english: 'Date',
  arabic: 'تاريخ',
};

export const TIME = {
  hebrew: 'שעה',
  english: 'Time',
  arabic: 'وقت',
};

export const TO_DIRECTION = {
  hebrew: 'לכיוון',
  english: 'To',
  arabic: 'ل',
};

export const FIRST_STATION = {
  hebrew: 'תחנה ראשונה',
  english: 'First station',
  arabic: 'المحطة الأولى',
};

export const LAST_STATION = {
  hebrew: 'תחנה אחרונה',
  english: 'Last station',
  arabic: 'المحطة الأخيرة',
};

export const SPECIAL_DATA_TEXTS = {
  accessible: {
    hebrew: 'נגיש',
    english: 'Accessible',
    arabic: 'يمكن الوصول إليها',
  },

  accessibleWithOrder: {
    hebrew: 'נגיש בהזמנה בלבד',
    english: 'Accessible by order only',
    arabic: 'يمكن الوصول إليها بالطلب فقط',
  },


  flexible: {
    hebrew: 'גמיש',
    english: 'Flexible',
    arabic: 'مرن',
  },
  specialMessges: {
    hebrew: 'הודעות',
    english: 'Messages',
    arabic: 'رسائل',
  },

  accessibleTooltip: {
    hebrew: 'קו נגיש לכיסא גלגלים',
    english: 'Accessible for wheelchairs',
    arabic: 'متاح للكراسي المحمولة',
  },

  accessibleWithOrderTooltip: {
    hebrew: 'קו זה דורש הזמנת נגישות מראש - לחץ לפרטים נוספים',
    english: 'This line requires advance booking for accessibility - click for more details',
    arabic: 'يتطلب هذا الخط حجز مسبق للوصول - انقر للحصول على التفاصيل',
  },

  /** aria-label for the accessible-line icon button in route details. */
  accessibleButtonAriaLabel: {
    hebrew: 'קו נגיש לכיסא גלגלים לחץ לפרטים נוספים',
    english: 'Wheelchair-accessible line, click for more details',
    arabic: 'خط متاح للكراسي المحمولة، انقر للحصول على التفاصيل',
  },

  /** aria-label when the accessible line requires advance booking. */
  accessibleWithOrderButtonAriaLabel: {
    hebrew: 'קו זה דורש הזמנת נגישות מראש לחץ לפרטים נוספים',
    english: 'This line requires advance booking for accessibility, click for more details',
    arabic: 'يتطلب هذا الخط حجز مسبق للوصول، انقر للحصول على التفاصيل',
  },

  flexibleTooltip: {
    hebrew: 'קו זה דורש הזמנה מראש - לחץ לפרטים נוספים',
    english: 'This line requires advance booking - click for more details',
    arabic: 'يتطلب هذا الخط حجز مسبق - انقر للحصول على التفاصيل',
  },
};

export const ORIGIN = {
  hebrew: 'מאיפה אתה יוצא',
  english: 'Where are you departing from',
  arabic: 'من أين تغادر؟',
};

export const DESTINATION = {
  hebrew: 'לאן אתה רוצה להגיע',
  english: 'Where do you want to arrive',
  arabic: 'إلى أين تريد الوصول؟',
};

export const SEARCH_ORIGIN = {
  hebrew: 'חפש מוצא',
  english: 'Search origin',
  arabic: 'أصل البحث',
};

export const SEARCH_DESTINATION = {
  hebrew: 'חפש יעד',
  english: 'Search Destination',
  arabic: 'وجهة البحث',
};

export const FILTERING_AND_SORTING = {
  hebrew: 'סינון ומיון',
  english: 'Filtering and sorting',
  arabic: 'التصفية والفرز',
};

export const PICK_STOP_CAR = {
  hebrew: 'בחרו את נקודת העצירה לרכב שלכם',
  english: 'Choose the stop point for your vehicle',
  arabic: 'اختر نقطة التوقف لسيارتك',
};

export const START_ON_CAR_DESC = {
  hebrew: 'התחילו את הנסיעה ברכב הפרטי והמשיכו בתחבורה ציבורית',
  english: 'Start the journey by private car and continue by public transport',
  arabic: 'ابدأ الرحلة بالسيارة الخاصة واستمر بالمواصلات العامة',
};

export const END_ON_CAR_DESC = {
  hebrew: 'התחילו את הנסיעה בתחבורה ציבורית והמשיכו ברכב הפרטי',
  english: 'Start the journey by public transport and continue by private car',
  arabic: 'ابدأ الرحلة باستخدام وسائل النقل العام واستمر بالسيارة الخاصة'
}

export const STOP_TYPE = {
  hebrew: 'סוג נקודת עצירה',
  english: 'Stop type',
  arabic: 'نوع التوقف',
};

export const STOP_ADDRESS = {
  hebrew: 'כתובת נקודת עצירה',
  english: 'Stop address',
  arabic: 'عنوان التوقف',
};

export const SEARCH_STOP_POINT = {
  hebrew: 'חפש נקודת עצירה',
  english: 'Search stop location',
  arabic: 'البحث عن موقع التوقف',
};

export const ADDRESS = {
  hebrew: 'כתובת',
  english: 'Address',
  arabic: 'عنوان',
};

export const TRAIN_STATIONS = {
  hebrew: 'תחנות רכבת',
  english: 'Train Stations',
  arabic: 'محطات القطار',
};

export const PARKING_LOTS = {
  hebrew: 'חניוני חנה וסע',
  english: 'Park & ride lots',
  arabic: 'مواقف السيارات والتنقل',
};

export const RAV_KAV_CHARGING_STATIONS = {
  hebrew: 'עמדות טעינת רב קו',
  english: 'Rav Kav charging stations',
  arabic: 'محطات شحن راف كاف',
};

export const PUBLIC_TRANSPORTATION_STATIONS = {
  hebrew: 'תחנות תחבורה ציבורית',
  english: 'Public transportation stations',
  arabic: 'محطات النقل العام',
};

export const GO_NOW = {
  hebrew: 'צא עכשיו',
  english: 'Leave now',
  arabic: 'غادر الآن',
};

export const START_ROUTE = {
  hebrew: 'התחל נסיעה',
  english: 'Start Route',
  arabic: 'ابدأ المسار',
};

export const ARRIVAL_AT = {
  hebrew: 'הגעה ב...',
  english: 'Arrival at...',
  arabic: 'الوصول إلى',
};

export const DEPARTURE_AT = {
  hebrew: 'יציאה ב...',
  english: 'Departure at...',
  arabic: 'المغادرة في',
};

/** aria-label for radiogroup: leave now / departure time / arrival time. */
export const TRIP_TIME_MODE_RADIO_GROUP_LABEL = {
  hebrew: 'בחירת סוג זמן נסיעה',
  english: 'Select trip time type',
  arabic: 'اختر نوع وقت الرحلة',
};

/** aria-label for radiogroup: search by station vs POI. */
export const STATION_SEARCH_TYPE_RADIO_GROUP_LABEL = {
  hebrew: 'סוג חיפוש',
  english: 'Search type',
  arabic: 'نوع البحث',
};

/** aria-label for radiogroup: first vs last leg with car. */
export const CAR_LEG_CHOICE_RADIO_GROUP_LABEL = {
  hebrew: 'שלב הנסיעה ברכב',
  english: 'Car journey segment',
  arabic: 'مرحلة الرحلة بالسيارة',
};

/** aria-label for radiogroup: day of week (letter buttons). */
export const DAY_OF_WEEK_RADIO_GROUP_LABEL = {
  hebrew: 'בחירת יום בשבוע',
  english: 'Select day of the week',
  arabic: 'اختيار يوم الأسبوع',
};

export const FIRST_LEG_ON_CAR = {
  hebrew: 'התחל נסיעה ברכב',
  english: 'Start journey with car',
  arabic: 'ابدأ الرحلة بالسيارة',
};

export const LAST_LEG_ON_CAR = {
  hebrew: 'סיים נסיעה ברכב',
  english: 'End journey with car',
  arabic: 'نهاية الرحلة بالسيارة',
};

export const LINE_NUMBER_AND_CITY = {
  hebrew: 'מספר קו ועיר',
  english: 'Line number and city',
  arabic: 'رقم الخط والمدينة',
};

export const LINE_SEARCHING = {
  hebrew: 'חיפוש קו',
  english: 'Line searching',
  arabic: 'البحث عن الخط',
};

export const DIRECTION = {
  hebrew: 'כיוון',
  english: 'Direction',
  arabic: 'اتجاه',
};

export const BOARDING_STATION = {
  hebrew: 'תחנת עלייה',
  english: 'Boarding station',
  arabic: 'محطة الصعود',
};

export const DROP_OFF_STATION = {
  hebrew: 'תחנת ירידה',
  english: 'Drop off station',
  arabic: 'محطة النزول',
};

/** Line route list: stops before selected boarding (greyed out), for heading + aria group */
export const PREVIOUS_STATIONS_HEADING = {
  hebrew: 'תחנות קודמות',
  english: 'Previous stations',
  arabic: 'محطات سابقة',
};

/** Line route list: stops between boarding and drop-off (main segment of the trip). */
export const MIDDLE_STATIONS_HEADING = {
  hebrew: 'תחנות במסלול הנסיעה',
  english: 'Stops along the trip',
  arabic: 'محطات على طول الرحلة',
};

/** Line route list: stops after the drop-off station (greyed out, continuation). */
export const AFTER_DROPOFF_STATIONS_HEADING = {
  hebrew: 'תחנות לאחר הירידה',
  english: 'Stops after drop-off',
  arabic: 'محطات بعد النزول',
};

/** Aria label for the line route stops list as a whole (used when no heading is exposed). */
export const LINE_STOPS_LIST_LABEL = {
  hebrew: 'רשימת תחנות הקו',
  english: 'Line stops list',
  arabic: 'قائمة محطات الخط',
};

/** Aria label for the turn-by-turn walking instructions inside a pedestrian segment. */
export const WALKING_DIRECTIONS_LIST_LABEL = {
  hebrew: 'הוראות הליכה',
  english: 'Walking directions',
  arabic: 'تعليمات المشي',
};

/**
 * Accessible names for the location icons in the address summary row
 * (origin / destination / intermediate stop). Each icon visually distinguishes
 * the role of the address; SR users get the role via role="img" + aria-label.
 */
export const ORIGIN_POINT_LABEL = {
  hebrew: 'נקודת מוצא',
  english: 'Origin point',
  arabic: 'نقطة الانطلاق',
};

export const DESTINATION_POINT_LABEL = {
  hebrew: 'נקודת יעד',
  english: 'Destination point',
  arabic: 'نقطة الوصول',
};

export const WAYPOINT_LABEL = {
  hebrew: 'עצירת ביניים',
  english: 'Intermediate stop',
  arabic: 'محطة وسيطة',
};

export const NO_PICKUP_OR_DROP_OFF = {
  hebrew: 'ללא איסוף או הורדה',
  english: 'No pickup or drop off at this stop',
  arabic: 'لا يمكن الاستقبال أو التسليم في هذه النقطة التوقف',
};

export const MANAGE_ROUTE_ALERT = {
  hebrew: 'אין לצאת מהדף או לנעול את המכשיר בניהול נסיעה',
  english: 'Do not leave the page or lock the device while riding',
  arabic: 'لا تترك الصفحة أو تقفل الجهاز أثناء إدارة الرحلة',
};

export const LINE_ALTERNATIVES_ORDER = {
  hebrew: 'לקו זה מספר חלופות, אנא בחר תחנת ירידה',
  english:
    'This line has several alternatives, please select a drop-off station',
  arabic: 'هذا الخط لديه عدة بدائل، يرجى تحديد محطة التسليم',
};

export const STATION_CODE = {
  hebrew: 'מספר תחנה',
  english: 'Station code',
  arabic: 'رمز المحطة',
};

export const PICK_DAY_AND_TIME = {
  hebrew: 'בחר יום ושעה',
  english: 'Pick day and time',
  arabic: 'اختيار اليوم والوقت',
};

export const PICK_DAY = {
  hebrew: 'בחר יום',
  english: 'Pick day',
  arabic: 'اختيר اليوم',
};

export const DAY = {
  hebrew: 'יום',
  english: 'Day',
  arabic: 'يوم',
};

export const RATE = {
  hebrew: 'דרג',
  english: 'Rate',
  arabic: 'معدل',
};

export const START_TRACK = {
  hebrew: 'התחל מסלול',
  english: 'Start track',
  arabic: 'بدء المسار',
};

export const RATINGS = {
  hebrew: 'דירוגים',
  english: 'Ratings',
  arabic: 'التقييمات',
};

export const ALREADY_RATED = {
  hebrew: 'כבר דירגת {0} זה',
  english: 'You already rated this {0}',
  arabic: 'لقد قمت بالفعل بتقييم هذا {0}',
};

export const SHARE = {
  hebrew: 'שיתוף',
  english: 'Share',
  arabic: 'يشارك',
};

export const LINE_ROUTE = {
  hebrew: 'מסלול הקו',
  english: 'Line Route',
  arabic: 'طريق الخط',
};

export const DAILY_CALENDAR = {
  hebrew: 'לו"ז יומי',
  english: 'Daily Calendar',
  arabic: 'التقويم اليومي',
};

export const SHOW_ON_MAP = {
  hebrew: 'הצג על מפה',
  english: 'Show on Map',
  arabic: 'تظهر على الخريطة',
};

export const ROUTE_PLANNING = {
  hebrew: 'תכנון מסלול',
  english: 'Route Planning',
  arabic: 'تخطيط الطريق',
};

export const FIND_A_ROUTE = {
  hebrew: 'מצא לי מסלול',
  english: 'Find a route',
  arabic: 'العثور على الطريق',
};

export const ADD_STOP = {
  hebrew: 'הוסף עצירה',
  english: 'Add stop',
  arabic: 'إضافة توقف',
};

// a11y: aria-label for the trash-icon button that removes the optional stop
// (waypoint) from the route. Previously labelled CLOSE ("סגור") which is
// misleading — SR users heard "close" but the button actually deletes the
// stop entry.
export const DELETE_STOP = {
  hebrew: 'מחיקת עצירה',
  english: 'Delete stop',
  arabic: 'حذف التوقف',
};

export const PICK_STOP = {
  hebrew: 'בחר עצירה',
  english: 'Pick stop',
  arabic: 'اختر توقف',
};

export const SHOW_PRICE = {
  hebrew: 'הצג חישוב מחיר',
  english: 'Show price calculation',
  arabic: 'عرض حساب السعر',
};

export const REMOVE_PRICE = {
  hebrew: 'הסר חישוב מחיר',
  english: 'Remove price calculation',
  arabic: 'إزالة حساب السعر',
};

export const FILTER = {
  hebrew: 'סינון',
  english: 'Filter',
  arabic: 'فلتر',
};

export const RESEARCH_WITHOUT_FILTER = {
  hebrew: 'לא נמצאו תוצאות עבור הסינונים המבוקשים, הנה כמה מסלולים חלופיים',
  english: 'No results were found for the requested filters, here are some alternative routes',
  arabic: 'لم يتم العثور على نتائج للمرشحات المطلوبة، إليك بعض الطرق البديلة',
};

export const AVAILABLE_ROUTES = {
  hebrew: 'מסלולים',
  english: 'Routes',
  arabic: 'الطرق',
};

export const SHARE_ROUTE = {
  hebrew: 'שתף מסלול',
  english: 'Share route',
  arabic: 'مشاركة الطريق',
};

export const SINGILE_RIDE = {
  hebrew: 'נסיעה בודדת',
  english: 'Single ride',
  arabic: 'رحلة واحدة',
};

export const DAILY_FREE = {
  hebrew: 'חופשי יומי',
  english: 'Daily free',
  arabic: 'يوميا مجانا',
};

export const MONTHLY_FREE = {
  hebrew: 'חופשי חודשי',
  english: 'Monthly free',
  arabic: 'شهريا مجانا',
};

export const FREE = {
  hebrew: 'חינם',
  english: 'Free',
  arabic: 'حر',
};

export const MINUTES = {
  hebrew: 'דקות',
  english: 'minutes',
  arabic: 'دقائق',
};

export const HOURS = {
  hebrew: 'שעות',
  english: 'hours',
  arabic: 'ساعات',
};

export const DAYS = {
  hebrew: 'ימים',
  english: 'days',
  arabic: 'أيام',
};

export const LEAVING_IN = {
  hebrew: 'יוצא בעוד ',
  english: 'Leaving in ',
  arabic: 'ترك في ',
};

export const LEAVING_AT = {
  hebrew: "יוצא ב ",
  english: "Leaving at ",
  arabic: "المغادرة عند "
}


export const FROM = {
  hebrew: 'מ',
  english: 'from ',
  arabic: 'من ',
};

export const NOW = {
  hebrew: 'עכשיו',
  english: 'now',
  arabic: 'الآن',
};

export const ROUTE_DURATION = {
  hebrew: 'משך מסלול',
  english: 'Route duration',
  arabic: 'مدة الطريق',
};

export const ROUTE_DETAILS = {
  hebrew: 'פרטי מסלול',
  english: 'Route details',
  arabic: 'تفاصيل الطريق',
};

/**
 * aria-label for clickable route result row (list). {0} = visible trip summary (date, times, duration).
 * Matches audit wording "פרטי המסלול" + existing line text.
 */
export const ROUTE_TRIP_OPTION_ARIA_LABEL = {
  hebrew: 'פרטי המסלול, {0}',
  english: 'Route details, {0}',
  arabic: 'تفاصيل المسار، {0}',
};

export const WALKING = {
  hebrew: 'הליכה',
  english: 'Walking',
  arabic: 'المشي',
};

export const WALKING_TO = {
  hebrew: 'הליכה אל',
  english: 'Walking to',
  arabic: 'المشي ل',
};

export const METER_SHORT = {
  hebrew: "מ'",
  english: "m'",
  arabic: "م'",
};

export const BUS = {
  hebrew: 'אוטובוס',
  english: 'bus',
  arabic: 'حافلة',
};

export const TRAIN = {
  hebrew: 'רכבת',
  english: 'train',
  arabic: 'يدرب',
};

export const LIGHT_TRAIN = {
  hebrew: 'רכבת קלה',
  english: 'light train',
  arabic: 'قطار خفيف',
};

export const CARMELIT = {
  hebrew: 'כרמלית',
  english: 'carmelit',
  arabic: 'قطار خفيف',
};

export const RAHBALIT = {
  hebrew: 'רכבלית',
  english: 'rahbalit',
  arabic: 'التلفريك',
};

export const PUBLIC_TAXI = {
  hebrew: 'מונית שירות',
  english: 'Public taxi',
  arabic: 'سيارة أجرة عامة',
};

export const CABLE_CAR = {
  hebrew: "רכבל",
  english: "cable car",
  arabic: "سيارة متعلقة بالسلك"
}

export const BOARD_ON = {
  hebrew: 'עלייה על',
  english: 'Board on',
  arabic: 'على متن الطائرة',
};

export const BOARD_OFF = {
  hebrew: 'ירידה בתחנה',
  english: 'Get off at station',
  arabic: 'انزل في المحطة',
};

export const BOARD_ON_AT_STATION = {
  hebrew: 'עלייה בתחנה',
  english: 'Get on at station',
  arabic: 'صعد في المحطة',
};

/** Shown in route tracking while waiting at the boarding stop (before user confirms on board). */
export const WAIT_FOR_LINE = {
  hebrew: 'המתינו לקו',
  english: 'Wait for line',
  arabic: 'انتظر خط',
};

export const STATION_PICTURE = {
  hebrew: 'תמונות תחנה',
  english: 'Station picture',
  arabic: 'صورة المحطة',
};

/**
 * Alt text template for a single station photo thumbnail.
 * Placeholders: {0} = 1-based image index, {1} = total photos, {2} = station name.
 * Allows assistive tech to distinguish between thumbnails and gives context
 * (the photo belongs to a specific station).
 */
export const STATION_PHOTO_ALT = {
  hebrew: 'תמונה {0} מתוך {1} של תחנת {2}',
  english: 'Photo {0} of {1} of station {2}',
  arabic: 'الصورة {0} من {1} للمحطة {2}',
};

/** Aria label for the clickable thumbnail (opens a fullscreen carousel). */
export const OPEN_STATION_PHOTO_ARIA_LABEL = {
  hebrew: 'פתח תמונה {0} מתוך {1} של תחנת {2} במצב מסך מלא',
  english: 'Open photo {0} of {1} of station {2} in fullscreen',
  arabic: 'افتح الصورة {0} من {1} للمحطة {2} في وضع ملء الشاشة',
};

/** Carousel navigation: previous slide. */
export const PREVIOUS_IMAGE = {
  hebrew: 'התמונה הקודמת',
  english: 'Previous image',
  arabic: 'الصورة السابقة',
};

/** Carousel navigation: next slide. */
export const NEXT_IMAGE = {
  hebrew: 'התמונה הבאה',
  english: 'Next image',
  arabic: 'الصورة التالية',
};

export const STATIONS = {
  hebrew: 'תחנות',
  english: 'Stations',
  arabic: 'محطات',
};

export const REACHED_DESTINATION = {
  hebrew: 'הגעת ליעדך',
  english: 'Reached destination',
  arabic: 'وصلت الوجهة',
};

export const FAVORITE_ROUTES = {
  hebrew: 'מסלולים מועדפים',
  english: 'Favorite routes',
  arabic: 'الطرق المفضلة',
};

export const EDIT = {
  hebrew: 'עריכה',
  english: 'Edit',
  arabic: 'يحرر',
};

export const SPECIAL_MESSAGES = {
  hebrew: 'הודעות מיוחדות',
  english: 'Special Messages',
  arabic: 'رسائل خاصة',
};

/**
 * Accessible name for the special-messages button: label + count in one announcement (badge is aria-hidden).
 */
export function specialMessagesButtonAriaLabel(
  languageKey: string,
  messageLabel: string,
  count: number
): string {
  if (!messageLabel) {
    return '';
  }
  if (count <= 0) {
    return messageLabel;
  }
  const separators: Record<string, string> = {
    hebrew: ', ',
    english: ', ',
    arabic: '، ',
  };
  const sep = separators[languageKey] ?? ', ';
  return `${messageLabel}${sep}${count}`;
}

export const CLOSE = {
  hebrew: 'סגור',
  english: 'Close',
  arabic: 'مغلق',
};

/**
 * a11y: accessible name for the sidebar's main top-back button (the
 * chevron + "תפריט" label). Per audit: "יש לשנות את השם של הכפתור
 * ל 'סגירת תפריט'" — the close button must be announced as "סגירת תפריט"
 * (Close menu), not the generic "סגור".
 */
export const CLOSE_MENU = {
  hebrew: 'סגירת תפריט',
  english: 'Close menu',
  arabic: 'إغلاق القائمة',
};

/**
 * a11y: accessible name for the hamburger button that opens the side menu.
 * Per audit: must not use the generic "Back" (חזרה) label — e.g. "פתיחת תפריט צד".
 */
export const OPEN_SIDE_MENU = {
  hebrew: 'פתיחת תפריט צד',
  english: 'Open side menu',
  arabic: 'فتح القائمة الجانبية',
};

/**
 * a11y: screen-reader announcement when a combobox list opens ({0} = item count,
 * {1} = first option label). Per audit: SR must hear that the list opened and
 * which item is first.
 */
export const COMBOBOX_LIST_OPENED = {
  hebrew: 'נפתחה רשימה, {0} פריטים. פריט ראשון: {1}',
  english: 'List opened, {0} items. First item: {1}',
  arabic: 'تم فتح القائمة، {0} عناصر. العنصر الأول: {1}',
};

export const CLEAR = {
  hebrew: 'נקה',
  english: 'Clear',
  arabic: 'امسح',
};

export const MORE_ACTIONS_MENU = {
  hebrew: 'פעולות נוספות',
  english: 'More actions',
  arabic: 'المزيد من الإجراءات',
};

export const AFFECTED_LINES = {
  hebrew: 'קווים מושפעים',
  english: 'Affected Lines',
  arabic: 'تتأثر الخطوط',
};

export const AFFECTED_STATIONS = {
  hebrew: 'תחנות מושפעות',
  english: 'Affected Stations',
  arabic: 'المحطات المتضررة',
};

export const BACK = {
  hebrew: 'חזרה',
  english: 'Back',
  arabic: 'العودة',
};

export const FROM_DATE = {
  hebrew: 'מתאריך',
  english: 'From Date',
  arabic: 'من تاريخ',
};

export const TO_DATE = {
  hebrew: 'עד תאריך',
  english: 'To Date',
  arabic: 'حتى الآن',
};


export const UNTIL = {
  hebrew: 'עד',
  english: 'until ',
  arabic: 'حتى ',
};

export const LAST_SEARCHES = {
  hebrew: 'חיפושים אחרונים',
  english: 'Last searches',
  arabic: 'عمليات البحث الأخيرة',
};

export const FAVORITE_LINES = {
  hebrew: 'קווים מועדפים',
  english: 'Favorite lines',
  arabic: 'الخطوط المفضلة',
};

export const MY_LOCATION = {
  hebrew: 'המיקום שלי',
  english: 'My location',
  arabic: 'موقعي',
};

export const PIN_INSERTION = {
  hebrew: "נעיצת סיכה",
  english: "Pin insertion",
  arabic: "إدخال العلامة",
};


export const SEARCH_ON_MAP = {
  hebrew: 'חיפוש במפה',
  english: 'Search on map',
  arabic: 'البحث على الخريطة',
};

export const FAVORITE_ADDRESSES = {
  hebrew: 'כתובות מועדפות',
  english: 'Favorite addresses',
  arabic: 'العناوين المفضلة',
};

export const HOME = {
  hebrew: 'בית',
  english: 'Home',
  arabic: 'بيت',
};

export const SET_HOME_ADDRESS = {
  hebrew: 'הגדר כתובת בית',
  english: 'Set a home address',
  arabic: 'تعيين عنوان المنزل',
};

export const WORK = {
  hebrew: 'עבודה',
  english: 'Work',
  arabic: 'عمل',
};

export const SET_WORK_ADDRESS = {
  hebrew: 'הגדר כתובת עבודה',
  english: 'Set a work address',
  arabic: 'قم بتعيين عنوان العمل',
};

export const ASK_FOR_POI = {
  hebrew: 'בקש נקודת עניין',
  english: 'Ask for point of interest',
  arabic: 'اسأل عن نقطة الاهتمام',
};

export const POI_REQUEST_SENT = {
  hebrew: 'בקשה להוספת נקודת עניין נשלחה',
  english: 'Point of interest request has been sent',
  arabic: 'تم إرسال طلب إضافة نقطة اهتمام',
};

export const NO_RESULT_FOUND = {
  hebrew: 'לא נמצאו תוצאות',
  english: 'No results found',
  arabic: 'لم يتم العثور على نتائج',
};

export const FOR = {
  hebrew: 'עבור',
  english: 'for',
  arabic: 'ل',
};

export const INSERT_ADDRESS = {
  hebrew: 'הכנס כתובת',
  english: 'Insert Address',
  arabic: 'أدخل العنوان',
};

export const INSERT_LINE_NUMBER_AND_CITY = {
  hebrew: 'הכנס מספר קו ועיר',
  english: 'Insert line number and city name',
  arabic: 'أدخل رقم السطر واسم المدينة',
};

export const THE_REQUESTED_PATH = {
  hebrew: 'המסלול המבוקש',
  english: 'the requested route',
  arabic: 'الطريق المطلوب',
};

export const NO_LINES_FOUND = {
  hebrew: 'לא נמצאו קווים',
  english: 'No lines found',
  arabic: 'لم يتم العثور على خطوط',
};

export const SORT_BY = {
  hebrew: 'מיין לפי',
  english: 'Sort by',
  arabic: 'فرز حسب',
};

export const TRANSPORT_METHODS = {
  hebrew: 'אמצעי תחבורה',
  english: 'Transport methods',
  arabic: 'طرق النقل',
};

export const ACCESSIBILLITY = {
  hebrew: 'נגישות',
  english: 'Accessibillity',
  arabic: 'إمكانية الوصول',
};

export const SHOW_ACCESSIBLE_TRANSPORT = {
  hebrew: 'הצג תחבורה נגישה בלבד',
  english: 'Show accessible transport only',
  arabic: 'عرض وسائل النقل الملائمة لذوي الاحتياجات الخاصة فقط',
};

export const CHANGES = {
  hebrew: 'סוג מסלול',
  english: 'Route type',
  arabic: 'نوع المسار',
};

export const MAX_TRAVEL_TIME = {
  hebrew: 'זמן מסלול מקסימלי',
  english: 'Maximum travel time',
  arabic: 'الحد الأقصى لوقت السفر',
};

export const MAX_WALKING_TIME = {
  hebrew: 'זמן הליכה מקסימלי',
  english: 'Maximum walking time',
  arabic: 'الحد الأقصى لوقت المشي',
};

export const APPLY_FILTERS = {
  hebrew: 'בצע סינון',
  english: 'Apply filters',
  arabic: 'تطبيق المرشحات',
};

export const APPLY_AND_SAVE_AS_DEFAULTS = {
  hebrew: 'בצע ושמור העדפות כברירת מחדל',
  english: 'Apply and save as default',
  arabic: 'قم بالتطبيق وحفظه كإعداد افتراضي',
};

export const CLEAR_FILTERS = {
  hebrew: 'נקה סננים',
  english: 'Clear filters',
  arabic: 'مرشحات واضحة',
};

export const FREQUENCY_AND_TRAVEL_TIME_SORT = {
  hebrew: 'שקלול של תדירות וזמן נסיעה',
  english: 'Weighting of frequency and travel time',
  arabic: 'ترجيح التردد ووقت السفر',
};

export const FASTEST_ROUTE_SORT = {
  hebrew: 'זמן מהיר ביותר למסלול',
  english: 'Fastest route',
  arabic: 'أسرع طريق',
};

export const LEAST_WALKING_TIME_SORT = {
  hebrew: 'הכי מעט זמן הליכה',
  english: 'Least amount of walking time',
  arabic: 'أقل قدر من وقت المشي',
};

export const LEAST_CHANGES_SORT = {
  hebrew: 'הכי מעט החלפות',
  english: 'Least amount of changes',
  arabic: 'أقل قدر من التغييرات',
};

export const WITH_CHANGES = {
  hebrew: 'עם החלפות',
  english: 'With changes',
  arabic: 'مع التغييرات',
};

export const WITHOUT_CHANGES = {
  hebrew: 'קו ישיר בלבד',
  english: 'Direct line only',
  arabic: 'خط مباشر فقط',
};

export const SHOW_ALL = {
  hebrew: 'הצג הכל',
  english: 'Show all',
  arabic: 'إظهار الكل',
};

export const FILL_DETAILS_FOR_POI = {
  hebrew: 'מלא את הפרטים על מנת לבקש את נקודת העניין',
  english: 'Fill details to ask for point of interest',
  arabic: 'املأ التفاصيل لطلب نقطة الاهتمام',
};

export const POI_NAME = {
  hebrew: 'שם נקודת העניין',
  english: 'Point of interest name',
  arabic: 'اسم نقطة الاهتمام',
};

export const MANDATORY_FIELD = {
  hebrew: 'שדה חובה',
  english: 'Mandatory field',
  arabic: 'حقل إلزامي',
};

export const SEND = {
  hebrew: 'שלח',
  english: 'Send',
  arabic: 'يرسل',
};

export const CANCEL = {
  hebrew: 'בטל',
  english: 'Cancel',
  arabic: 'يلغي',
};

export const ORIGIN_DESTINATION = {
  hebrew: 'מוצא-יעד',
  english: 'Origin-Destination',
  arabic: 'الوجهة الأصلية',
};

export const SEARCH_BY_LINE = {
  hebrew: 'לפי קו',
  english: 'Search by line',
  arabic: 'خط البحث',
};

export const SEARCH_BY_STATION = {
  hebrew: 'לפי תחנה',
  english: 'Search by station',
  arabic: 'البحث عن طريق الخط',
};

export const INTERCITY_LINES = {
  hebrew: 'קווים בין יישובים',
  english: 'Intercity lines',
  arabic: 'خطوط بين المدن',
};

export const CAR_INTEGRATED_ROUTE = {
  hebrew: 'מסלול בשילוב רכב',
  english: 'Car integrated route',
  arabic: 'مسار السيارة المتكامل',
};

export const HEBREW = {
  hebrew: 'עברית',
  english: 'hebrew',
  arabic: 'العبرية',
};

export const ENGLISH = {
  hebrew: 'אנגלית',
  english: 'english',
  arabic: 'إنجليزي',
};

export const ARABIC = {
  hebrew: 'ערבית',
  english: 'arabic',
  arabic: 'عربي',
};

// a11y: localized labels for Angular Material MatDatepickerIntl.
// Used by LocalizedMatDatepickerIntl service so the calendar toggle / prev / next /
// "choose month and year" buttons announce a Hebrew/Arabic name instead of the
// English defaults baked into @angular/material.
export const CALENDAR_LABEL = {
  hebrew: 'לוח שנה',
  english: 'Calendar',
  arabic: 'التقويم',
};

export const OPEN_CALENDAR_LABEL = {
  hebrew: 'פתח את לוח השנה',
  english: 'Open calendar',
  arabic: 'افتح التقويم',
};

export const CLOSE_CALENDAR_LABEL = {
  hebrew: 'סגור את לוח השנה',
  english: 'Close calendar',
  arabic: 'أغلق التقويم',
};

export const PREVIOUS_MONTH_LABEL = {
  hebrew: 'החודש הקודם',
  english: 'Previous month',
  arabic: 'الشهر السابق',
};

export const NEXT_MONTH_LABEL = {
  hebrew: 'החודש הבא',
  english: 'Next month',
  arabic: 'الشهر التالي',
};

export const PREVIOUS_YEAR_LABEL = {
  hebrew: 'השנה הקודמת',
  english: 'Previous year',
  arabic: 'السنة السابقة',
};

export const NEXT_YEAR_LABEL = {
  hebrew: 'השנה הבאה',
  english: 'Next year',
  arabic: 'السنة التالية',
};

export const PREVIOUS_MULTI_YEAR_LABEL = {
  hebrew: '20 השנים הקודמות',
  english: 'Previous 20 years',
  arabic: 'العشرون سنة السابقة',
};

export const NEXT_MULTI_YEAR_LABEL = {
  hebrew: '20 השנים הבאות',
  english: 'Next 20 years',
  arabic: 'العشرون سنة التالية',
};

export const SWITCH_TO_MONTH_VIEW_LABEL = {
  hebrew: 'בחר תאריך',
  english: 'Choose date',
  arabic: 'اختر التاريخ',
};

export const SWITCH_TO_MULTI_YEAR_VIEW_LABEL = {
  hebrew: 'בחר חודש ושנה',
  english: 'Choose month and year',
  arabic: 'اختر الشهر والسنة',
};

export const START_DATE_LABEL = {
  hebrew: 'תאריך התחלה',
  english: 'Start date',
  arabic: 'تاريخ البدء',
};

export const END_DATE_LABEL = {
  hebrew: 'תאריך סיום',
  english: 'End date',
  arabic: 'تاريخ الانتهاء',
};

export const COMPARISON_DATE_LABEL = {
  hebrew: 'תאריך להשוואה',
  english: 'Comparison date',
  arabic: 'تاريخ المقارنة',
};

// a11y: accessible name for the tariff-profile <mot-select> combobox (the
// dropdown that shows "רגיל" / "Regular" next to the price toggle). The select
// has no visible <mat-label>, so without this aria-label screen readers
// announce just "combobox, Regular, collapsed" with no hint at the field's
// purpose.
export const TARIFF_PROFILE_LABEL = {
  hebrew: 'פרופיל תעריף',
  english: 'Tariff profile',
  arabic: 'الملف الشخصي للأجرة',
};

export const FAVORITE_STATIONS = {
  hebrew: 'תחנות מועדפות',
  english: 'Favorite Stations',
  arabic: 'المحطات المفضلة',
};

export const FAVORITES_MANAGEMENT = {
  hebrew: 'ניהול מועדפים',
  english: 'Favorites managment',
  arabic: 'إدارة المفضلة',
};

export const NEW_FAVORITE = {
  hebrew: 'מועדף חדש',
  english: 'New favorite',
  arabic: 'المفضلة الجديدة',
};

export const EDIT_FAVORITE = {
  hebrew: 'עריכת מועדף',
  english: 'Edit Favorite',
  arabic: 'تحرير المفضلة',
};

export const FAVORITE_TYPE = {
  hebrew: 'סוג מועדף',
  english: 'Favorite type',
  arabic: 'النوع المفضل',
};

export const ADD_FAVORITE = {
  hebrew: 'הוסף מועדף',
  english: 'Add favorite',
  arabic: 'إضافة المفضلة',
};

export const SAVE_FAVORITE = {
  hebrew: 'שמור מועדף',
  english: 'Save favorite',
  arabic: 'حفظ المفضلة',
};

export const ADD_TO_FAVORITES = {
  hebrew: 'הוסף למועדפים',
  english: 'Add to favorites',
  arabic: 'إضافة إلى المفضلة',
};

export const REMOVE_FROM_FAVORITES = {
  hebrew: 'הסר מהמועדפים',
  english: 'Remove from favorites',
  arabic: 'إزالة من المفضلة',
};

export const FIND_LINES = {
  hebrew: 'מצא קווים',
  english: 'Find lines',
  arabic: 'العثور على خطوط',
};

export const SEARCH_LINE = {
  hebrew: 'חפש קו',
  english: 'Search line',
  arabic: 'خط البحث',
};

export const STATION_SEARCHING = {
  hebrew: 'חיפוש תחנה',
  english: 'Station searching',
  arabic: 'بحث المحطة',
};

export const SEARCH_ADDRESS = {
  hebrew: 'חיפוש כתובת',
  english: 'Search address',
  arabic: 'العنوان البحث',
};

export const STATION_NAME_NUMBER_ADDRESS = {
  hebrew: 'שם/מספר/כתובת תחנה',
  english: 'Station name/number/address',
  arabic: 'اسم المحطة/الرقم/العنوان',
};

export const FIND_STATION = {
  hebrew: 'מצא תחנה',
  english: 'Find station',
  arabic: 'ابحث عن المحطة',
};

export const STATION_DETAILS = {
  hebrew: 'פרטי תחנה',
  english: 'Station details',
  arabic: 'تفاصيل المحطة',
};

export const LINES_CALENDAR = {
  hebrew: 'לו"ז קווים',
  english: 'Lines calendar',
  arabic: 'تقويم الخطوط',
};

export const LINES_IN_STATION = {
  hebrew: 'קווים בתחנה',
  english: 'Lines in station',
  arabic: 'خطوط في المحطة',
};

export const POINTS_OF_INTEREST = {
  hebrew: 'נקודות עניין',
  english: 'Points of interest',
  arabic: 'نقاط الاهتمام',
};

export const ADD_TO_CALENDAR = {
  hebrew: 'הוסף ליומן',
  english: 'Add to calendar',
  arabic: 'أضف إلى التقويم',
};

export const SUBMIT_REQUEST_COMPLAIN = {
  hebrew: 'הגש פניה/תלונה',
  english: 'Submit a request/complaint',
  arabic: 'تقديم طلب/شكوى',
};

export const NAVIGATE_TO_STATION = {
  hebrew: 'נווט לתחנה',
  english: 'Navigate to station',
  arabic: 'انتقل إلى المحطة',
};

export const ROUTE_TRACKING = {
  hebrew: 'ניהול נסיעה',
  english: 'Route Tracking',
  arabic: 'تتبع المسار',
};

export const SIGN_UP_FOR_REPORTS = {
  hebrew: 'הרשמה לדיווחים',
  english: 'Sign up for reports',
  arabic: 'قم بالتسجيل للحصول على التقارير',
};

/** External signup URL (8787 Midaat). */
export const SIGN_UP_FOR_REPORTS_URL = 'https://www.8787.org.il/Midaat/';

/**
 * a11y: supplementary hint for the "Sign up for reports" external link.
 *
 * Rendered as a visually-hidden span INSIDE the <a> (visible label + this
 * hint together form the accessible name). We do NOT put it on aria-label
 * because:
 *  - aria-label would override the visible <span> text, and some
 *    screen readers (notably iOS VoiceOver + Safari with target="_blank")
 *    end up reading both the visible text and the aria-label, plus the
 *    auto-injected "link" role announcement, producing a duplicated
 *    "...link, ..., link" pattern (see a11y audit screenshot).
 *  - Visible-text-plus-sr-only-hint is the pattern recommended by WCAG
 *    techniques G91/H30 and avoids the duplication entirely.
 *
 * The hint MUST NOT include the word "link"/"קישור"/"رابط" — screen readers
 * already announce the <a> role as "link", so adding it here would still
 * cause a duplicate readout.
 *
 * The leading comma gives screen readers a natural pause between the
 * visible label and the hint.
 */
export const SIGN_UP_FOR_REPORTS_EXTERNAL_HINT = {
  hebrew: ', אתר חיצוני, נפתח בכרטיסייה חדשה',
  english: ', external website, opens in a new tab',
  arabic: '، موقع خارجي، يفتح في علامة تبويب جديدة',
};

export const DAYS_LETTERS = {
  hebrew: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ש'"],
  english: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  arabic: ['أ', 'إ', 'ث', 'أ', 'خ', 'ج', 'س'],
};

export const DAYS_NAMES = {
  hebrew: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
  english: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  arabic: [
    'الأحد',
    'الإثنين',
    'الثلاثاء',
    'الأربعاء',
    'الخميس',
    'الجمعة',
    'السبت',
  ],
};

export const EXTENDED_DETAILS = {
  hebrew: 'פרטים מורחבים',
  english: 'Extended details',
  arabic: 'تفاصيل موسعة',
};

export const SEARCH_STATION = {
  hebrew: 'חפש תחנה',
  english: 'Search station',
  arabic: 'محطة البحث',
};

export const NO_STATION_FOUND = {
  hebrew: 'לא נמצאו תחנות',
  english: 'No stations found',
  arabic: 'لم يتم العثور على محطات',
};

export const IN_LINES = {
  hebrew: 'בקווים',
  english: 'In lines',
  arabic: 'في الخطوط',
};

export const STATIONS_WILL_BE_CANCLED = {
  hebrew: 'יבוטלו תחנות',
  english: 'Stations will be cancelled',
  arabic: 'سيتم إلغاء المحطات',
};

export const INSTEAD_LINES_WILL_GO_IN_STATIONS = {
  hebrew: 'במקומן יעברו הקווים בתחנות',
  english: 'In their place, the lines will pass through the stations',
  arabic: 'وبدلاً من ذلك، ستمر الخطوط عبر المحطات',
};

export const THERE_MAY_BE_CHANGES = {
  hebrew: 'ייתכנו שינויים',
  english: 'There may be changes',
  arabic: 'قد تكون هناك تغييرات',
};

export const TRIPS_WILL_BE_ADDED = {
  hebrew: 'יתווספו נסיעות',
  english: 'Trips will be added',
  arabic: 'سيتم إضافة الرحلات',
};

export const TRIPS_WILL_BE_CANCELLED = {
  hebrew: 'יבוטלו נסיעות',
  english: 'Trips will be cancelled',
  arabic: 'سيتم إلغاء الرحلات',
};

export const SIGNIFICANT_DELAYS_WILL_BE_EXPERIENCED = {
  hebrew: 'יורגשו עיכובים משמעותיים',
  english: 'Significant delays will be experienced',
  arabic: 'سيتم تجربة تأخيرات كبيرة',
};

export const SHOW_ADDITIONAL_INFO = {
  hebrew: 'הצג מידע נוסף',
  english: 'Show additional information',
  arabic: 'عرض معلومات إضافية',
};

export const HIDE_ADDITIONAL_INFO = {
  hebrew: 'הסתר מידע נוסף',
  english: 'Hide additional information',
  arabic: 'إخفاء معلومات إضافية',
};

export const UNKNOWN_CAUSE = {
  hebrew: 'סיבה לא ידועה',
  english: 'Unknown cause',
  arabic: 'سبب غير معروف',
};

export const OTHER_CAUSE = {
  hebrew: 'סיבה אחרת',
  english: 'Other cause',
  arabic: 'سبب آخر',
};

export const TECHNICAL_PROBLEM = {
  hebrew: 'תקלה טכנית',
  english: 'Technical problem',
  arabic: 'مشكلة فنية',
};

export const STRIKE = {
  hebrew: 'שביתה',
  english: 'Strike',
  arabic: 'يضرب',
};

export const DEMONSTRATION = {
  hebrew: 'הפגנה',
  english: 'Demonstration',
  arabic: 'توضيح',
};

export const ACCIDENT = {
  hebrew: 'תאונה',
  english: 'Accident',
  arabic: 'حادثة',
};

export const HOLIDAY = {
  hebrew: 'חג',
  english: 'Holiday',
  arabic: 'عطلة',
};

export const WEATHER = {
  hebrew: 'מזג אוויר',
  english: 'Weather',
  arabic: 'طقس',
};

export const MAINTENANCE = {
  hebrew: 'תחזוקה',
  english: 'Maintenance',
  arabic: 'صيانة',
};

export const CONSTRUCTION = {
  hebrew: 'עבודות בכביש',
  english: 'Construction',
  arabic: 'بناء',
};

export const POLICE_ACTIVITY = {
  hebrew: 'פעילות משטרתית',
  english: 'Police Activity',
  arabic: 'نشاط الشرطة',
};

export const MEDICAL_EMERGENCY = {
  hebrew: 'מקרה חירום רפואי',
  english: 'Medical Emergency',
  arabic: 'الطوارئ الطبية',
};

export const DUE_TO = {
  hebrew: 'עקב',
  english: 'Due to',
  arabic: 'بسبب',
};

export const STATION_CANCELLED_UNTIL = {
  hebrew: 'תחנה זו מבוטלת עד',
  english: 'This station is cancelled until',
  arabic: 'تم إلغاء هذه المحطة حتى',
};

export const IN_TIME = {
  hebrew: 'בשעה',
  english: 'at',
  arabic: 'في',
};

export const STATIONS_LIST = {
  hebrew: 'רשימת תחנות',
  english: 'Stations list',
  arabic: 'قائمة المحطات',
};

export const ALTERNATIVE_STATIONS_LIST = {
  hebrew: 'רשימת תחנות חלופיות',
  english: 'List of alternative stations',
  arabic: 'قائمة المحطات البديلة',
};

export const LINE = {
  hebrew: 'קו',
  english: 'Line',
  arabic: 'خط',
};

export const ROUTE = {
  hebrew: 'מסלול',
  english: 'Route',
  arabic: 'طريق',
};

export const STATION = {
  hebrew: 'תחנה',
  english: 'Station',
  arabic: 'محطة',
};

export const STATION_CANCELLED = {
  hebrew: 'תחנה מבוטלת',
  english: 'Station cancelled',
  arabic: 'تم إلغاء المحطة',
};

export const ALTERNATIVE_STATION = {
  hebrew: 'תחנה חלופית',
  english: 'Alternative station',
  arabic: 'محطة بديلة',
};

export const ORDER_SEAT = {
  hebrew: 'הזמנת מקום מראש',
  english: 'Reserve a seat in advance',
  arabic: 'حجز مقعد مقدما',
};

export const CONTACT_INFO = {
  hebrew: 'מידע ליצירת קשר',
  english: 'Contact information',
  arabic: 'معلومات الاتصال',
};

export const PLEASE_CONTACT_WITH = {
  hebrew: 'להזמנת מקום אנא צור קשר עם',
  english: 'To reserve a seat please contact with',
  arabic: 'لحجز مقعد يرجى التواصل مع',
};

export const IN_NUMBER = {
  hebrew: 'במספר',
  english: 'In phone number',
  arabic: 'في رقم الهاتف',
};

export const OR_IN_WEBSITE = {
  hebrew: 'או באתר',
  english: 'or in website',
  arabic: 'أو في الموقع'
}

export const PHONE_NUMBER = {
  hebrew: 'מספר טלפון',
  english: 'Phone number',
  arabic: 'رقم التليفون',
};

export const WEBSITE = {
  hebrew: 'אתר',
  english: 'Website',
  arabic: 'موقع إلكتروني',
};

/**
 * aria-label for agency website link in contact popup. {0} = agency name.
 * States purpose (operator site) and that the link opens in a new tab.
 *
 * NOTE: Do NOT include the word "link"/"קישור"/"رابط". The <a> element already
 * exposes the "link" role, so a screen reader would otherwise announce
 * "link, link to {agency}'s website..." — a duplicate, confusing the user.
 */
export const AGENCY_WEBSITE_LINK_ARIA_LABEL = {
  hebrew: 'אתר האינטרנט של {0}, נפתח בכרטיסייה חדשה',
  english: "{0}'s website, opens in a new tab",
  arabic: 'موقع {0} على الإنترنت، يفتح في علامة تبويب جديدة',
};

export const INSERT_EMAIL_ADDRESS = {
  hebrew: 'הכנס את כתובת המייל האלקטרוני שלך',
  english: 'Insert your email address',
  arabic: 'أدخل عنوان بريدك الإلكتروني',
};

export const EMAIL = {
  hebrew: 'מייל',
  english: 'Email',
  arabic: 'بريد إلكتروني',
};

export const ALLOW = {
  hebrew: 'אפשר',
  english: 'Allow',
  arabic: 'يسمح',
};

export const DONT_ALLOW = {
  hebrew: 'אל תאפשר',
  english: 'Dont allow',
  arabic: 'لا تسمح',
};

export const LOCATION_PERMISSION_REQUIRED = {
  hebrew: 'יש לאפשר הרשאות גישה למיקום',
  english: 'Location permissions required',
  arabic: 'مطلوب إذن الموقع',
};

export const ALLOW_USE_LOCATION = {
  hebrew: 'אפשר לנו לגשת למיקום שלך',
  english: 'Allow us to access your location',
  arabic: 'اسمح لنا بالوصول إلى موقعك',
};

export const ALLOW_USE_LOCATION_DESC = {
  hebrew: 'נשתמש בזה כדי לעזור לך להגיע ליעד בצורה קלה ונוחה, צעד צעד',
  english:
    'We will use this to help you reach your destination in an easy and convenient way, step by step',
  arabic:
    'سنستخدم هذا لمساعدتك في الوصول إلى وجهتك بطريقة سهلة ومريحة، خطوة بخطوة',
};

export const LOCATION_PERMISSION_DENIED = {
  hebrew: 'יש להפעיל את שירותי המיקום בהגדרות המכשיר כדי להשתמש בתכונה זו',
  english:
    'Please enable location services in device settings to use this feature',
  arabic: 'يرجى تمكين خدمات الموقع في إعدادات الجهاز لاستخدام هذه الميزة',
};

export const OK_BUTTON = {
  hebrew: 'אישור',
  english: 'OK',
  arabic: 'موافق',
};

export const PERSONALIZED_BROWSING_EXPERIENCE = {
  hebrew: 'חווית גלישה מותאמת אישית',
  english: 'Personalized browsing experience',
  arabic: 'تجربة تصفح شخصية',
};

export const ALLOW_COOKIES_DESC = {
  hebrew:
    'אתר האינטרנט שלנו משתמש בקובצי Cookies על מנת לתמוך בחווית המשתמש שלך באתר זה. על ידי המשך הגלישה באתר אתה נותן את הסכמתך לשימוש שלנו ב-cookies.',
  english:
    'Our website uses cookies to support your user experience on this website. By continuing to browse the website, you give your consent to our use of cookies.',
  arabic:
    'يستخدم موقعنا ملفات تعريف الارتباط لدعم تجربة المستخدم الخاصة بك على هذا الموقع. من خلال الاستمرار في تصفح الموقع، فإنك تعطي موافقتك على استخدامنا لملفات تعريف الارتباط.',
};

export const AGREE = {
  hebrew: 'מסכימ/ה',
  english: 'Agree',
  arabic: 'موافق',
};

export const DONT_AGREE = {
  hebrew: 'לא מסכימ/ה',
  english: "Don't agree",
  arabic: 'لا أوافق',
};

export const SEARCH_BY = {
  hebrew: 'חפש לפי',
  english: 'Search by',
  arabic: 'لبحث عن طريق',
};

export const PICK_ORIGIN = {
  hebrew: 'בחר מוצא',
  english: 'Pick origin',
  arabic: 'اختيار الأصل',
};

export const PICK_DESTINATION = {
  hebrew: 'בחר יעד',
  english: 'Pick destination',
  arabic: 'اختر الوجهة',
};

export const PICK_ADDRESS = {
  hebrew: 'בחר כתובת',
  english: 'Pick address',
  arabic: 'اختيار العنوان',
};

export const KM_SHORT = {
  hebrew: 'ק"מ',
  english: 'km',
  arabic: 'كم',
};

export const TRAVELING_BY_CAR = {
  hebrew: 'נסיעה ברכב',
  english: 'Traveling by car',
  arabic: 'السفر بالسيارة',
};

export const LINK_COPIED = {
  hebrew: 'הקישור הועתק בהצלחה',
  english: 'Link copied successfully',
  arabic: 'تم نسخ الرابط بنجاح',
};

export const SEARCHING_FOR_LINES = {
  hebrew: 'מחפש קווים...',
  english: 'Searching for lines...',
  arabic: 'البحث عن خطوط...',
};

export const PREPARING_PRINT_VIEW = {
  hebrew: 'מכין תצוגת הדפסה, הפעולה עשויה להימשך כדקה...',
  english: 'Preparing print view, this may take up to a minute...',
  arabic: 'جارٍ إعداد عرض الطباعة، قد تستغرق العملية دقيقة تقريبًا...',
};


export const BUS_APPROACHING = {
  hebrew: 'האוטובוס כבר מגיע לתחנה!',
  english: 'The bus is approaching your stop!',
  arabic: 'الحافلة تقترب من محطتك!',
};

export const DROP_OFF_APPROACHING = {
  hebrew: 'שים לב! תחנת הירידה מתקרבת!',
  english: 'Attention! Your drop-off stop is approaching!',
  arabic: 'انتبه! محطة النزول تقترب!',
};

export const DID_YOU_BOARD_BUS = {
  hebrew: 'האם עלית על האוטובוס?',
  english: 'Did you get on the bus?',
  arabic: 'هل صعدت إلى الحافلة؟',
};

export const YES = {
  hebrew: 'כן',
  english: 'Yes',
  arabic: 'نعم',
};

export const NO = {
  hebrew: 'לא',
  english: 'No',
  arabic: 'لا',
};

export const CANT_FIND_USER_LOCATION_ADDRESS = {
  hebrew: "לצערנו לא הצלחנו לאתר את מיקומך. יש לבדוק את הרשאות השימוש במיקום בהגדרות האפליקציה או להזין את הכתובת באופן ידני",
  english: "Unfortunately we were unable to find your location. Please check the app’s location permissions in settings or enter the address manually",
  arabic: "للأسف لم نتمكن من تحديد موقعك. يرجى التحقق من أذونات الموقع في إعدادات التطبيق أو إدخال العنوان يدويًا"
};

export const CANT_FIND_USER_LOCATION_STATION = {
  hebrew: "לצערנו לא הצלחנו למצוא את מיקומך, יש להזין תחנה באופן ידני",
  english: "Unfortunately we were unable to find your location, please enter the station manually",
  arabic: "لسوء الحظ لم نتمكن من العثور على موقعك، يرجى إدخال المحطة يدويًا"
}

export const GENERAL_ERROR = {
  hebrew: 'אופס! קרתה תקלה, אנא נסה שנית או צור קשר עם מוקד השירות בטלפון: *8787',
  english:
    'Oops! An error occurred, Please try again or contact the service center by phone: *8787',
  arabic: 'عفواً! حدث خطأ, يُرجى المحاولة مرة أخرى أو الاتصال بمركز الخدمة على الهاتف: *8787',
};

export const TAXI_CALCULATOR = {
  hebrew: 'מחשבון מוניות',
  english: 'Taxi Calculator',
  arabic: 'حاسبة سيارات الأجرة',
};

export const TARIFF_PAGE = {
  hebrew: 'עמוד תעריפים',
  english: 'Tariff Page',
  arabic: 'صفحة التعريفة',
};

export const RAV_KAV_DETAILS = {
  hebrew: 'דף פרטים רב קו',
  english: 'Rav Kav Details',
  arabic: 'تفاصيل راف كاف',
};

export const PUBLIC_TRANSPORT_UPDATES = {
  hebrew: 'הודעות ועדכונים בתחבורה ציבורית',
  english: 'Public Transport Updates',
  arabic: 'تحديثات وسائل النقل العام',
};

export const PICK_A_TIME_IN_THE_FUTURE = {
  hebrew: "יש לבחור זמן בעתיד",
  english: "Choose a time in the future",
  arabic: "اختر وقتًا في المستقبل"
}

export const DROP_OFF_ONLY = {
  hebrew: "הורדה בלבד",
  english: "Drop off only",
  arabic: "النزول فقط"
}

export const PICK_UP_ONLY = {
  hebrew: "איסוף בלבד",
  english: "Pick up only",
  arabic: "الاستقبال فقط"
}

export const CONTACT_US = {
  hebrew: 'צור קשר',
  english: 'Contact Us',
  arabic: 'اتصل بنا',
};

/** Ministry contact modal: WhatsApp / Telegram action labels (content otherwise from CMS API). */
export const CONTACT_VIA_WHATSAPP = {
  hebrew: 'צור קשר דרך WhatsApp',
  english: 'Contact via WhatsApp',
  arabic: 'اتصل عبر واتساب',
};

export const CONTACT_VIA_TELEGRAM = {
  hebrew: 'צור קשר דרך Telegram',
  english: 'Contact via Telegram',
  arabic: 'اتصل عبر تيليجرام',
};

/** Default text appended when opening wa.me / t.me without API deep link. */
export const CONTACT_SOCIAL_PREFILL_MESSAGE = {
  hebrew: 'שלום, אני מעוניין במידע נוסף',
  english: "Hello, I'm interested in more information",
  arabic: 'مرحباً، أنا مهتم بمزيد من المعلومات',
};

export const SUBMIT_COMPLAIN = {
  hebrew: 'הגשת פנייה',
  english: 'Complaint',
  arabic: 'قدم شكوى',
};


export const REQUEST_SENT = {
  hebrew: 'הבקשה נשלחה בהצלחה',
  english: 'Request sent successfully',
  arabic: 'تم إرسال الطلب بنجاح',
};

export const PLATFORM = {
  hebrew: "רציף",
  english: "Platform",
  arabic: "المنصة"
}

export const DEPARTURE_FROM_PLATFORM = {
  hebrew: "יציאה מרציף",
  english: "Departure from platform",
  arabic: "الخروج من المنصة"
}

export const TIMES_LEGEND = {
  hebrew: "מקרא זמנים",
  english: "Times legend",
  arabic: "مقرر الوقت"
}

export const RATING_SENT_SUCCESSFULLY = {
  hebrew: "הדירוג נשלח בהצלחה ✔",
  english: "Rating sent successfully ✔",
  arabic: "تم إرسال التقييم بنجاح ✔"
}

export const RATING_ERROR = {
  hebrew: "שגיאה בשליחת הדירוג ✖",
  english: "Error sending rating ✖",
  arabic: "خطأ في إرسال التقييم ✖"
}

export const HOW_TO_RATE_STATION = {
  hebrew: "כיצד תרצה לדרג את התחנה?",
  english: "How do you want to rate the station?",
  arabic: "كيف تريد تقييم المحطة؟"
}
export const HOW_TO_RATE_LINE = {
  hebrew: "כיצד תרצה לדרג את הקו?",
  english: "How do you want to rate the line?",
  arabic: "كيف تريد تقييم الخط؟"
}

/** aria-label for each star radio option in rating popup. {0} = 1–5 */
export const RATING_STAR_OPTION_ARIA = {
  hebrew: 'בחר דירוג של {0} מתוך 5 כוכבים',
  english: 'Select rating {0} out of 5 stars',
  arabic: 'اختر تقييمًا {0} من 5 نجوم',
};

/** aria-label for read-only star display (average). {0} = numeric average */
export const RATING_READONLY_ARIA = {
  hebrew: 'דירוג ממוצע {0} מתוך 5 כוכבים',
  english: 'Average rating {0} out of 5 stars',
  arabic: 'متوسط التقييم {0} من 5 نجوم',
};

export const DELETE = {
  hebrew: "מחק",
  english: "Delete",
  arabic: "حذف"
}

export const DELETE_FAVORITE = {
  hebrew: "האם אתה בטוח שברצונך למחוק מועדף זה?",
  english: "Are you sure you want to delete this favorite?",
  arabic: "هل أنت متأكد أنك تريد حذف هذا المفضل؟"
}

/**
 * a11y: accessible name for the trash-icon button next to each favorite item
 * in the "Manage Favorites" dialog. The button only shows a trash glyph
 * (aria-hidden), so without this aria-label screen readers announce it as an
 * unnamed "button, dialog" — audit flagged it as having no accessible name.
 * Sibling pair to `EDIT_FAVORITE` (used on the pen-icon button).
 */
export const DELETE_FAVORITE_BUTTON = {
  hebrew: 'מחיקת מועדף',
  english: 'Delete favorite',
  arabic: 'حذف المفضلة',
};

export const TYPE_TIME_24_HOURS = {
  hebrew: "יש להזין את הזמן הרצוי בפורמט 24 שעות",
  english: "Please enter the desired time in 24 hour format",
  arabic: "يرجى إدخال الوقت المرغوب فيه بتنسيق 24 ساعة"
}

export const PICK_MAP_LOCATION_TEXT = {
  hebrew: "נעץ על גבי המפה את המיקום הרצוי.",
  english: "Place the marker on the map of the desired location.",
  arabic: "ضع العلامة على الخريطة لموقع المرغوب فيه."
}

export const CLICK_STATION_TO_SEE_DETAILS = {
  hebrew: "לחץ על התחנה על מנת לראות את פרטיה. ",
  english: "Click on the station to see the details.",
  arabic: "انقر على المحطة لعرض التفاصيل."
}

export const PICK_STATION = {
  hebrew: "בחר תחנה",
  english: "Pick station",
  arabic: "اختيار المحطة"
}

export const PRINT = {
  hebrew: "הדפס",
  english: "Print",
  arabic: "طباعة"
}

/** Aria-label for Print menu item (downloads file to computer). */
export const PRINT_ARIA_LABEL = {
  hebrew: 'הדפס - הורדת קובץ למחשב',
  english: 'Print - download file to computer',
  arabic: 'طباعة - تنزيل الملف إلى الكمبيوتر'
};

export const FLEXIBLE_SERVICE = {
  hebrew: "שירות גמיש",
  english: "Flexible service",
  arabic: "خدمة مرنة"
}

export const ACCESSIBLE_LINE = {
  hebrew: "קו נגיש",
  english: "Accessible line",
  arabic: "خط متاح"
}

export const ACCESSIBLE_LINE_CALL_NEEDED = {
  hebrew: "קו נגיש בהזמנה בלבד",
  english: "Accessible line by call only",
  arabic: "خط متاح فقط بالاتصال"
}

export const LINE_CROWDEDNESS = {
  hebrew: "מדד הצפיפות",
  english: "Crowdedness index",
  arabic: "مؤشر الكثافة"
}

/**
 * Localized accessible names for the crowdedness indicator icons.
 * The icon alone conveys information (low/medium/high), so sighted users
 * see colored people glyphs; SR users get one of these strings as the
 * image `alt` on the crowdedness SVG.
 */
export const CROWDEDNESS_LIGHT = {
  hebrew: 'צפיפות נמוכה',
  english: 'Low crowdedness',
  arabic: 'كثافة منخفضة',
};

export const CROWDEDNESS_MEDIUM = {
  hebrew: 'צפיפות בינונית',
  english: 'Medium crowdedness',
  arabic: 'كثافة متوسطة',
};

export const CROWDEDNESS_HEAVY = {
  hebrew: 'צפיפות גבוהה',
  english: 'High crowdedness',
  arabic: 'كثافة عالية',
};

export const CROWDEDNESS_UNKNOWN = {
  hebrew: 'אין מידע על צפיפות',
  english: 'Crowdedness unknown',
  arabic: 'الكثافة غير معروفة',
};

/** Alt text for the empty-state illustration shown when a table has no rows. */
export const ALT_TABLE_EMPTY = {
  hebrew: 'אין נתונים להצגה',
  english: 'No data to display',
  arabic: 'لا توجد بيانات للعرض',
};

export const ARRIVAL_TIME = {
  hebrew: "שעת הגעה",
  english: "Arrival time",
  arabic: "وقت الوصول"
}


export const DEPARTURE_TIME = {
  hebrew: "שעת יציאה",
  english: "Departure time",
  arabic: "وقت الانطلاق"
}

export const RESERVE_IS_POSSIBLE = {
  hebrew: "ניתן להזמין מקום",
  english: "Reserve seat is possible",
  arabic: "الحجز ممكن"
}

export const LINE_NOT_ACTIVE_ON_SELECTED_DAY = {
  hebrew: "הקו אינו פעיל ביום זה",
  english: "The line is out of service on this day",
  arabic: "الخط غير فعال في هذا اليوم"
}

export const LINE_WILL_RETURN_ON_DAY = {
  hebrew: "הקו יחזור ביום",
  english: "The line will return on",
  arabic: "الخط سيعود في"
}

export const STATION_NOT_ACTIVE = {
  hebrew: "בתחנה זו לא קיימות נסיעות פעילות",
  english: "There are no active trips at this station",
  arabic: "لا توجد رحلات فعالة في هذه المحطة"
}

export const EXACT_ARRIVAL_TIME = {
  hebrew: "זמן הגעה מדוייק",
  english: "Exact arrival time",
  arabic: "وقت الوصول الدقيق"
}

export const PLANNED_ARRIVAL_TIME = {
  hebrew: "זמן הגעה מתוכנן",
  english: "Planned arrival time",
  arabic: "وقت الوصول المخطط"
}

export const EXIT_ORIGIN_STATION = {
  hebrew: "יציאה מתחנת מוצא",
  english: "Exit from departure station",
  arabic: "الخروج من محطة المغادرة"
}

export const ARRIVAL_DESTINATION_STATION = {
  hebrew: "הגעה לתחנת יעד",
  english: "Arrival to destination station",
  arabic: "وصول إلى محطة الوجهة"
}


export const DIDNT_ADD_FAVORITE_ROUTES = {
  hebrew: "עדיין לא הוספת מסלולים מועדפים",
  english: "You haven't added any favorite routes yet",
  arabic: "لم تضاف أي طرق مفضلة بعد"
}

export const DIDNT_ADD_FAVORITE_STATIONS = {
  hebrew: "עדיין לא הוספת תחנות מועדפות",
  english: "You haven't added any favorite stations yet",
  arabic: "لم تضاف أي محطات مفضلة بعد"
}

export const DIDNT_ADD_FAVORITE_LINES = {
  hebrew: "עדיין לא הוספת קווים מועדפים",
  english: "You haven't added any favorite lines yet",
  arabic: "لم تضاف أي خطوط مفضلة بعد"
}

export const SEARCH = {
  hebrew: "חפש...",
  english: "Search...",
  arabic: "بحث"
}

export const MENU = {
  hebrew: "תפריט",
  english: "Menu",
  arabic: "القائمة"
}

export const LOGO_ALT = {
  hebrew: 'לוגו הרשות הארצית לתחבורה ציבורית',
  english: 'National Public Transportation Authority logo',
  arabic: 'شعار الهيئة الوطنية للنقل العام',
}

/** Aria-label for the swap-locations icon button (origin ↔ destination). */
export const SWITCH_LOCATIONS = {
  hebrew: 'החלף בין מוצא ויעד',
  english: 'Swap origin and destination',
  arabic: 'تبديل الأصل والوجهة',
}

/** Generic "increase" verb for stepper/slider plus buttons. */
export const INCREASE = {
  hebrew: 'הגדל',
  english: 'Increase',
  arabic: 'زيادة',
}

/** Generic "decrease" verb for stepper/slider minus buttons. */
export const DECREASE = {
  hebrew: 'הקטן',
  english: 'Decrease',
  arabic: 'تقليل',
}

/** aria-label for the clock icon button that opens the time picker panel. */
export const SELECT_TIME = {
  hebrew: 'בחירת שעה',
  english: 'Select time',
  arabic: 'اختيار الوقت',
};

/** Singular noun "hour" for time picker stepper aria-labels. */
export const HOUR = {
  hebrew: 'שעה',
  english: 'hour',
  arabic: 'ساعة',
}

/** Singular noun "minute" for time picker stepper aria-labels. */
export const MINUTE = {
  hebrew: 'דקה',
  english: 'minute',
  arabic: 'دقيقة',
}

export const CHOOSE_LANGUAGE = {
  hebrew: "בחר שפה",
  english: "Choose language",
  arabic: "اختر اللغة"
}

/**
 * aria-label template for the language switcher trigger button.
 * `{0}` is replaced with the current language label (e.g. "עברית").
 * Mirrors mot-website-client `sidebar.languageMenuButton` so screen-reader
 * users get full context: "Choose site language. Current: {x}".
 */
export const LANGUAGE_MENU_BUTTON_ARIA_LABEL = {
  hebrew: 'בחר את שפת האתר. נוכחית: {0}',
  english: 'Choose site language. Current: {0}',
  arabic: 'اختر لغة الموقع. الحالية: {0}',
}

/**
 * Suffix appended to the currently active language option's aria-label.
 * Example: "עברית, נבחר" so SR announces "Hebrew, selected".
 */
export const LANGUAGE_SELECTED = {
  hebrew: 'נבחר',
  english: 'selected',
  arabic: 'محدد',
}

/**
 * Suffix announced for links that open in a new tab/window (target="_blank").
 * Append in parentheses to a link's accessible name so SR users are warned
 * that activation will switch context.
 */
export const OPENS_IN_NEW_TAB = {
  hebrew: 'נפתח בכרטיסייה חדשה',
  english: 'opens in a new tab',
  arabic: 'يفتح في علامة تبويب جديدة',
}

/**
 * aria-label template for a submenu opened by a top-nav disclosure button.
 * `{0}` is replaced with the parent menu item title.
 * Used as the accessible name on the dropdown panel (role="group") so SR
 * users know which top-level item the submenu belongs to.
 */
export const SUBMENU_FOR = {
  hebrew: 'תת-תפריט עבור {0}',
  english: 'Submenu for {0}',
  arabic: 'القائمة الفرعية لـ {0}',
}

/** Sidebar nav disclosure: appended to section title for expand/collapse button name. */
export const MENU_DISCLOSURE_COLLAPSED = {
  hebrew: 'מכווץ',
  english: 'collapsed',
  arabic: 'مطوي',
};

export const MENU_DISCLOSURE_EXPANDED = {
  hebrew: 'מורחב',
  english: 'expanded',
  arabic: 'موسع',
};

export const AFTER_MIDNIGHT = {
  hebrew: "לאחר חצות",
  english: "After midnight",
  arabic: "بعد الظهر"
}

export const FOR_MORE_INFO = {
  hebrew: 'למידע נוסף : www.bus.gov.il / *8787',
  english: 'For more information: www.bus.gov.il / *8787',
  arabic: 'للحصول على معلومات إضافية: www.bus.gov.il / *8787',
}

/**
 * Accessible name for the tab strip's "scroll forward" pagination chevron
 * (the > arrow Material renders when there are more tabs than fit). Audit:
 * by default Material marks these aria-hidden + tabindex="-1"; we expose
 * them as real focusable buttons with this label.
 */
export const NEXT_TAB = {
  hebrew: 'הכרטיסייה הבאה',
  english: 'Next tab',
  arabic: 'علامة التبويب التالية',
}

/**
 * Accessible name for the tab strip's "scroll backward" pagination chevron
 * (the < arrow Material renders when there are more tabs than fit).
 */
export const PREVIOUS_TAB = {
  hebrew: 'הכרטיסייה הקודמת',
  english: 'Previous tab',
  arabic: 'علامة التبويب السابقה',
}

/**
 * Accessible name for the lines list inside a station card on the POI
 * results page. Audit: SR users had no way to know they were looking at a
 * list of bus lines stopping at the station - the badges were rendered as
 * unlabelled <div>s. Wrapping them in a <ul aria-label="..."> exposes them
 * as a proper list. Used by stations-result-list-item-lines.component.
 */
export const LINES_AT_STATION = {
  hebrew: 'קווים בתחנה',
  english: 'Lines at this station',
  arabic: 'الخطوط في هذه المحطة',
}

/**
 * Accessible name pattern for a single bus-line badge inside a station
 * card. {0} = line number/name (e.g. "3", "א3"), {1} = agency name.
 * SR announces "Line 3, Egged" instead of just reading two adjacent
 * standalone tokens.
 */
export const LINE_BADGE_ARIA_LABEL = {
  hebrew: 'קו {0}, {1}',
  english: 'Line {0}, {1}',
  arabic: 'خط {0}، {1}',
}

/**
 * Accessible name pattern for the "+N more" badge that appears when a stop
 * has more than 7 lines and we collapse the tail. {0} = number of hidden
 * lines. Audit required every visible token to have an explicit name; the
 * "+N" badge by itself is ambiguous out of context.
 */
export const MORE_LINES_COUNT = {
  hebrew: 'ועוד {0} קווים',
  english: '{0} more lines',
  arabic: '{0} خطوط أخرى',
}

/**
 * Accessible name for the back/close chevron rendered by app-results-header
 * at the top of every results slide-up (search-by-station, search-by-line,
 * route-details, etc.). Audit: the chevron was an icon-only button with no
 * accessible name, so SR users heard just "button" with no purpose.
 */
export const RESULTS_HEADER_BACK = {
  hebrew: 'חזרה',
  english: 'Back',
  arabic: 'العودة',
}

export const CHOOSE_VIEW = {
  hebrew: 'בחר תצוגה',
  english: 'Choose view',
  arabic: 'اختر العرض',
}

/**
 * Accessible name pattern for a single station card in the POI results
 * list. Audit: SR users could not tell each card apart - they only heard
 * the inner texts read one after another with no grouping. Wrapping each
 * card in <li aria-label="..."> announces the whole card as a single
 * semantic unit. {0} = station name, {1} = station-code label
 * ("Station code"), {2} = station code number, {3} = lines summary
 * (e.g. "8 lines"). Lines summary is optional - when zero it is omitted.
 */
export function stationCardAriaLabel(
  languageKey: string,
  stationName: string,
  stationCodeLabel: string,
  stationCode: string | number,
  linesCount: number,
  linesAtStationLabel: string
): string {
  const separators: Record<string, string> = {
    hebrew: ', ',
    english: ', ',
    arabic: '، ',
  };
  const sep = separators[languageKey] ?? ', ';
  const parts: string[] = [stationName, `${stationCodeLabel} ${stationCode}`];
  if (linesCount > 0) {
    parts.push(`${linesAtStationLabel} ${linesCount}`);
  }
  return parts.filter(Boolean).join(sep);
}

export const SITE_INTRO_TITLE = {
  hebrew: 'הכירו את המסלולן!',
  english: 'Meet the Route Planner!',
  arabic: 'تعرف على مخطط المسار!',
};

export const SITE_INTRO_DESCRIPTION = {
  hebrew: 'ברוכים הבאים לאתר החדש של הרשות הארצית לתחבורה ציבורית!\nכאן תוכלו לתכנן את הדרך שלכם באוטובוסים, ברכבת הקלה וברכבת ישראל, ולקבל עדכונים בזמן אמת, בקלות ובמהירות.',
  english: 'Welcome to the new website of the National Authority for Public Transportation!\nHere you can plan your journey by buses, light rail, and Israel Railways, and receive real-time updates, easily and quickly.',
  arabic: 'مرحبًا بكم في الموقع الجديد للسلطة الوطنية للمواصلات العامة!\nهنا يمكنكم تخطيط طريقكم بالحافلات، والقطار الخفيف، وقطار إسرائيل، والحصول على تحديثات في الوقت الفعلي، بسهولة وسرعة.',
};

export const SITE_INTRO_DESCRIPTION_2 = {
  hebrew: '* שימו לב: האתר כעת בהרצה והמסלולים הם בגדר המלצה בלבד. השימוש במידע באתר הינו באחריות המשתמש בלבד.',
  english: '* Please note: The website is currently in a trial run and the routes are recommendations only. The use of information on the website is the sole responsibility of the user.',
  arabic: '* يرجى الانتباه: الموقع حاليًا في مرحلة تجريبية والمسارات هي بمثابة توصية فقط. استخدام المعلومات في الموقع يقع على مسؤولية المستخدم فقط.',
};


export const SITE_INTRO_MORE_INFO = {
  hebrew: 'למידע נוסף',
  english: 'More information',
  arabic: 'لمزيد من المعلومات',
};

export const SITE_INTRO_CLOSE = {
  hebrew: 'סגירה',
  english: 'Close',
  arabic: 'إغلاق',
};

export const SITE_INTRO_DONT_SHOW_AGAIN = {
  hebrew: 'סגירה ואל תציגו שוב',
  english: 'Close and don\'t show again',
  arabic: 'إغلاق ولا تعرض مرة أخرى',
};

export const ONE_STATION = {
  hebrew: 'תחנה אחת',
  english: 'One station',
  arabic: 'محطة واحدة',
};

export const SHOW_LINE_CALENDAR = {
  hebrew: 'הצג לו"ז קו',
  english: 'Show line calendar',
  arabic: 'عرض تقويم الخط',
}
